var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExerciseClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 6.66659C10.9206 6.66659 11.6668 5.92039 11.6668 4.99992C11.6668 4.07944 10.9206 3.33325 10.0002 3.33325C9.07969 3.33325 8.3335 4.07944 8.3335 4.99992C8.3335 5.92039 9.07969 6.66659 10.0002 6.66659Z",
    fill: "#2F54EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.3333V11.6667C15.6333 11.6667 14.0333 10.8667 12.8333 9.43333L11.7167 8.1C11.4 7.71667 10.9333 7.5 10.4417 7.5H9.56667C9.075 7.5 8.60833 7.71667 8.29167 8.1L7.175 9.43333C5.96667 10.8667 4.36667 11.6667 2.5 11.6667V13.3333C4.80833 13.3333 6.825 12.3583 8.33333 10.625V12.5L5.1 13.7917C4.54167 14.0167 4.16667 14.5667 4.16667 15.175C4.16667 16 4.83333 16.6667 5.65833 16.6667H7.5V16.25C7.5 15.1 8.43333 14.1667 9.58333 14.1667H12.0833C12.3167 14.1667 12.5 14.35 12.5 14.5833C12.5 14.8167 12.3167 15 12.0833 15H9.58333C8.89167 15 8.33333 15.5583 8.33333 16.25V16.6667H14.3417C15.1667 16.6667 15.8333 16 15.8333 15.175C15.8333 14.5667 15.4583 14.0167 14.9 13.7917L11.6667 12.5V10.625C13.175 12.3583 15.1917 13.3333 17.5 13.3333Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExerciseClose);
export default __webpack_public_path__ + "static/media/icon_exercise_close.817d9fe9e854bffeac76a2376f4e36a2.svg";
export { ForwardRef as ReactComponent };